import type { Perimetre, PerimetreAvecCommunesOuCads } from "models";
import { Endpoints } from "enums";
import { collectivitesApiClient } from "./apiClients";

/**
 * Récupère tous les périmètres du SDEA
 * @returns Array<Perimetre>
 */
async function getAll(): Promise<Array<Perimetre>> {
  const url = Endpoints.PERIMETRES;
  return collectivitesApiClient.get(url);
}

/**
 * Récupère un périmètre en fonction de son id
 * @param id l'id du périmètre recherché
 * @returns un périmètre
 */
async function getById(id: string): Promise<Perimetre> {
  const url = `/${Endpoints.PERIMETRES}/${id}`;
  return collectivitesApiClient.get(url);
}

/**
 * Récupère tous les périmètres et leurs relations avec les communes
 */
async function getPerimetresAvecCommunes(): Promise<Array<PerimetreAvecCommunesOuCads>> {
  const url = Endpoints.PERIMETRES_AVEC_COMMUNES;
  return collectivitesApiClient.get(url);
}

export const perimetresService = {
  getAll,
  getById,
  getPerimetresAvecCommunes,
};
